import React, { useEffect, useState } from "react";
import socket from './../socket.js'


export default function PaymentResult() {
  const [status, setStatus] = useState("checking");
  const [credit, setCredit] = useState(null);
  const [message, setMessage] = useState(
    "در حال بررسی پرداخت شما..."
  );
  const token=localStorage.getItem ('token');
  useEffect(() => {
    //if (!socket) return;

    // --------------------------------
    // در حال بررسی پرداخت
    // --------------------------------
    const handlePaymentChecking = (data) => {
      setStatus("checking");

      setMessage(
        data?.message || "در حال بررسی پرداخت شما..."
      );
    };

    // --------------------------------
    // پرداخت با موفقیت تأیید شده
    // --------------------------------
    const handlePaymentConfirmed = (data) => {
      setCredit(data?.credit ?? null);

      // اگر دستگاه همان لحظه شارژ شده
      if (data?.chargeStatus === "completed") {
        setStatus("charged");

        setMessage(
          data?.message ||
            "پرداخت با موفقیت انجام شد و دستگاه شما شارژ شد."
        );
      }

      // اگر دستگاه آفلاین است
      else {
        setStatus("offline");

        setMessage(
          data?.message ||
            "پرداخت با موفقیت انجام شد، اما دستگاه شما در حال حاضر آفلاین است. شارژ پس از اتصال دستگاه به صورت خودکار انجام می‌شود."
        );
      }
    };

    // --------------------------------
    // دستگاه شارژ شد
    // --------------------------------
    const handleChargeCompleted = (data) => {
      setStatus("charged");

      setCredit(data?.credit ?? null);

      setMessage(
        data?.message ||
          "دستگاه شما با موفقیت شارژ شد."
      );
    };

    // --------------------------------
    // پرداخت موفق، ولی شارژ منتظر دستگاه است
    // --------------------------------
    const handleChargePending = (data) => {
      setStatus("offline");

      setCredit(data?.credit ?? null);

      setMessage(
        data?.message ||
          "پرداخت با موفقیت انجام شد. دستگاه شما در حال حاضر آفلاین است و پس از اتصال، به صورت خودکار شارژ خواهد شد."
      );
    };

    // --------------------------------
    // پرداخت ناموفق
    // --------------------------------
    const handlePaymentFailed = (data) => {
      setStatus("failed");

      setMessage(
        data?.message ||
          "پرداخت تأیید نشد. لطفاً دوباره تلاش کنید."
      );
    };

    const handleWaite_charge = (data) => {
      setStatus("charged");

      setMessage(
        data?.message ||
          "در حال ارسال شارژ به دستگاه ..."
      );
    };
    // --------------------------------
    // ثبت Listener ها
    // --------------------------------

    socket.on(
      "payment_checking",
      handlePaymentChecking
    );

    socket.on(
      "payment_confirmed",
      handlePaymentConfirmed
    );

    socket.on(
      "charge_completed",
      handleChargeCompleted
    );

    socket.on(
      "charge_pending",
      handleChargePending
    );

    socket.on(
      "payment_failed",
      handlePaymentFailed
    );
    socket.on(
      "waite_charge",
      handleWaite_charge
    );

    // --------------------------------
    // اعلام بازگشت کاربر از درگاه
    // --------------------------------
    const params = new URLSearchParams (window.location.search);
    const paymentInfo ={
      trackId:params.get ("trackId"),
      success:params.get ("success"),
      status: params.get ("status"),
      orderId:params.get ("orderId")

    }
    socket.emit("payment_returned",{token:token,paymentInfo:paymentInfo});

    // --------------------------------
    // پاک کردن Listener ها
    // --------------------------------

    return () => {
      socket.off(
        "payment_checking",
        handlePaymentChecking
      );

      socket.off(
        "payment_confirmed",
        handlePaymentConfirmed
      );

      socket.off(
        "charge_completed",
        handleChargeCompleted
      );

      socket.off(
        "charge_pending",
        handleChargePending
      );

      socket.off(
        "payment_failed",
        handlePaymentFailed
      );
      socket.off(
        "waite_charge",
        handleWaite_charge
      );
    };
  }, [socket]);

  // --------------------------------
  // وضعیت‌های صفحه
  // --------------------------------

  const isChecking = status === "checking";
  const isCharged = status === "charged";
  const isOffline = status === "offline";
  const isFailed = status === "failed";

  return (
    <div
      dir="rtl"
      className="
        min-h-screen
        bg-black
        text-white
        flex
        items-center
        justify-center
        px-4
        py-8
      "
    >
      
      <div
          className="
            relative
            overflow-hidden
            rounded-3xl
            border
            border-white/10
            bg-zinc-950
            shadow-2xl
            shadow-black/50
          "
        >

          {/* خط بالای کارت */}

          <div className="absolute top-0 left-0 right-0 h-1 bg-orange-500" />

          <div className="p-6 sm:p-8 text-center">

            {/* ========================= */}
            {/* ICON */}
            {/* ========================= */}

            <div className="flex justify-center mb-6">

              {/* در حال بررسی */}

              {isChecking && (
                <div
                  className="
                    w-20
                    h-20
                    rounded-full
                    border-4
                    border-zinc-700
                    border-t-orange-500
                    animate-spin
                  "
                />
              )}

              {/* موفق */}

              {isCharged && (
                <div
                  className="
                    w-20
                    h-20
                    rounded-full
                    bg-green-500/10
                    border
                    border-green-500/30
                    flex
                    items-center
                    justify-center
                  "
                >
                  <svg
                    className="w-10 h-10 text-green-400"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2.5"
                  >
                    <path d="M5 12.5L9.5 17L19 7.5" />
                  </svg>
                </div>
              )}

              {/* دستگاه آفلاین */}

              {isOffline && (
                <div
                  className="
                    w-20
                    h-20
                    rounded-full
                    bg-orange-500/10
                    border
                    border-orange-500/30
                    flex
                    items-center
                    justify-center
                  "
                >
                  <svg
                    className="w-10 h-10 text-orange-400"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="1.8"
                  >
                    <path d="M12 3V13" />
                    <path d="M7.05 7.05a7 7 0 1 0 9.9 0" />
                  </svg>
                </div>
              )}

              {/* خطا */}

              {isFailed && (
                <div
                  className="
                    w-20
                    h-20
                    rounded-full
                    bg-red-500/10
                    border
                    border-red-500/30
                    flex
                    items-center
                    justify-center
                  "
                >
                  <svg
                    className="w-10 h-10 text-red-400"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                  >
                    <path d="M7 7L17 17" />
                    <path d="M17 7L7 17" />
                  </svg>
                </div>
              )}

            </div>

            {/* ========================= */}
            {/* TITLE */}
            {/* ========================= */}

            <h1
              className="
                text-2xl
                sm:text-3xl
                font-bold
                mb-3
              "
            >

              {isChecking &&
                "در حال بررسی پرداخت"}

              {isCharged &&
                "پرداخت و شارژ موفق بود"}

              {isOffline &&
                "پرداخت با موفقیت انجام شد"}

              {isFailed &&
                "پرداخت ناموفق بود"}

            </h1>
            {/* ========================= */}
            {/* MESSAGE */}
            {/* ========================= */}

            <p
              className="
                text-zinc-400
                leading-7
                text-sm
                sm:text-base
              "
            >
              {message}
            </p>

            {/* ========================= */}
            {/* CREDIT */}
            {/* ========================= */}

            {credit !== null && !isFailed && (
              <div
                className="
                  mt-7
                  rounded-2xl
                  bg-white/[0.04]
                  border
                  border-white/10
                  p-5
                "
              >

                <div className="text-zinc-500 text-sm mb-2">
                  اعتبار خریداری‌شده
                </div>

                <div
                  className="
                    text-3xl
                    font-extrabold
                    text-cyan-400
                  "
                >
                  {Number(credit).toLocaleString("fa-IR")}
                </div>

                <div className="text-zinc-500 text-sm mt-1">
                  شارژ بازی
                </div>

              </div>
            )}

            {/* ========================= */}
            {/* OFFLINE MESSAGE */}
            {/* ========================= */}

            {isOffline && (
              <div
                className="
                  mt-6
                  rounded-2xl
                  border
                  border-orange-500/20
                  bg-orange-500/5
                  p-4
                  text-right
                "
              >

                <div className="flex gap-3 items-start">

                  <span className="text-orange-400 text-lg">
                    !
                  </span>

                  <div>

                    <div
                      className="
                        text-orange-300
                        font-semibold
                        mb-1
                      "
                    >
                      دستگاه آفلاین است
                    </div>

                    <div
                      className="
                        text-zinc-500
                        text-sm
                        leading-6
                      "
                    >
                      نیازی به پرداخت مجدد نیست.
                      پس از آنلاین شدن دستگاه،
                      اعتبار شما به صورت خودکار
                      برای آن ارسال می‌شود.
                    </div>

                  </div>

                </div>

              </div>
            )}

            {/* ========================= */}
            {/* BUTTON */}
            {/* ========================= */}

            <button
              type="button"
              onClick={() => {
                window.location.href = "/charge";
              }}
              className="
                w-full
                mt-7
                rounded-2xl
                bg-orange-500
                hover:bg-orange-400
                active:bg-orange-600
                text-black
                font-bold
                py-3.5
                transition
              "
            >
              بازگشت به صفحه شارژ
            </button>

            {/* ========================= */}
            {/* FOOTER */}
            {/* ========================= */}

            <div
              className="
                mt-4
                text-xs
                text-zinc-600
              "
            >
              وضعیت پرداخت توسط سرور بررسی و تأیید می‌شود.
            </div>

          </div>
        </div>
      </div>
    
  );
}